import { module } from 'angular';
import { ngModule as foundationThemingModule } from 'cg-foundation-theming';
import { AddToFavouritesDialogueComponent } from './components/add-to-favourites-dialogue';
import { AddToFavouritesButtonDirective } from './directives/add-to-favourites-button';
import { ViewFavouritesDirective } from './directives/view-favourites';
import { ViewFavouritesFullDirective } from './directives/view-favourites-full';
import { FavouritesService } from './services/favourites-service';
import '../scss/_master.scss';
export var ngModule = module('gn.audio.cg.favourites', [foundationThemingModule.name])
    .service('favouritesService', FavouritesService)
    .component('addToFavouritesDialogue', AddToFavouritesDialogueComponent)
    .directive('addToFavouritesButton', AddToFavouritesButtonDirective)
    .directive('viewFavourites', ViewFavouritesDirective)
    .directive('viewFavouritesFull', ViewFavouritesFullDirective);
